
const productTitleNode = document.querySelector('.product__info-container > .product__title');
if (productTitleNode) {
    const productSectionNode = document.querySelector('.product-section-wrap.product');
    const clonedNode = productTitleNode.cloneNode(true);
    clonedNode.classList.add('product__title--mobile');
    productSectionNode.insertAdjacentElement('afterbegin', clonedNode);
}

const productPrice = document.querySelector('.product__info-wrapper .price-text-wrap');
if (productPrice) {
    const instock = document.querySelector('.product__info-wrapper .instock');
    const clonedNode1 = productPrice.cloneNode(true);
    clonedNode1.classList.add('product__quantity--mobile');
    instock?.insertAdjacentElement('beforebegin', clonedNode1);
}

const productDelivery = document.querySelector('.product__info-wrapper .product_delivery_date');
if (productDelivery) {
    const pickupAvailability = document.querySelector('.product__info-wrapper pickup-availability');
    const clonedNode2 = productDelivery.cloneNode(true);
    clonedNode2.classList.add('product_delivery_date--mobile');
    pickupAvailability?.insertAdjacentElement('beforebegin', clonedNode2);
}


const sliders = document.querySelectorAll('slider-component.main-gallery .slider__slide');
if (sliders && galleryCaption.length>0) {
    for (let i = 0; i < galleryCaption.length; i++) {
        sliders[i].querySelector('.caption-conent .content').innerHTML = galleryCaption[i].content;
        sliders[i].querySelector('.caption').innerHTML = galleryCaption[i].caption;
    }
}
const captionFN = (e) => {
    e.nextElementSibling.classList.add('show');

}
const closeTooltip = (e) => {
    e.closest('.caption-conent').classList.remove('show');
}

const reviewsAttachPoint = document.querySelector('.product__title--mobile');
(function pollForProductReviews() {
    if (document.querySelector(".stamped-product-reviews-badge .stamped-badge-caption")) {
        // desktop - review badge modifications
        const desktopReviewBadgeElem = document.querySelector('.product__info-wrapper .stamped-badge-caption');
        const reviewsCount = desktopReviewBadgeElem.dataset.reviews;
        const rating = desktopReviewBadgeElem.dataset.rating;
        const label = desktopReviewBadgeElem.dataset.label;
        desktopReviewBadgeElem.innerHTML = `${rating} (${reviewsCount} ${label})`;

        // mobile - review badge modifications
        const reviewsBadgeElem = document.querySelector(".stamped-product-reviews-badge");
        const reviewsSectionElem = reviewsBadgeElem.closest('.shopify-app-block');
        const cloneReviewsSectionElem = reviewsSectionElem.cloneNode(true);
        cloneReviewsSectionElem.classList.add('product-reviews-badge--mobile');
        reviewsAttachPoint.insertAdjacentElement('afterend', cloneReviewsSectionElem);

        if (document.querySelector('.product-reviews-badge--mobile .stamped-badge-caption')) {
            const badgeCaptionElem = document.querySelector('.product-reviews-badge--mobile .stamped-badge-caption');
            const reviewsCount = badgeCaptionElem.dataset.reviews;
            const rating = badgeCaptionElem.dataset.rating;
            badgeCaptionElem.innerHTML = `${rating} (${reviewsCount})`;
        }

    }
    else {
        setTimeout(pollForProductReviews, 25);
    }
})();

(function partnerWidget() {
    if (document.querySelector('.partner-widget')) {
        const partnerWidget = document.querySelector('.partner-widget');
        if (partnerWidget) {
            const productMediaWrapper = document.querySelector('.grid__item.product__media-wrapper')
            const clonedNode3 = partnerWidget.cloneNode(true);
            clonedNode3.classList.add('partner-widget--mobile');
            productMediaWrapper.insertAdjacentElement('beforebegin', clonedNode3);
        }
    }
    else {
        setTimeout(partnerWidget, 25);
    }
})();

setTimeout(()=>{
  const mobileSliderThumbnail = document.querySelector('.product__media-wrapper .thumbnail-slider');
  mobileSliderThumbnail && mobileSliderThumbnail.classList.add('thumb-show');
},2000);